export const TOGGLE_OPTIMIZER = 'TOGGLE_OPTIMIZER';

export const toggleOptimizer = (val) => ({
    type: TOGGLE_OPTIMIZER,
    val,
});
